import { Box, FormControlLabel, FormHelperText, Checkbox } from '@mui/material'

type FocusCheckboxGroupProps = {
  value?: string[]
  onChange?: (value: string[]) => void
  onBlur?: () => void
  options: { label: string; value: string }[]
  error?: boolean
  helperText?: string
}

export const FocusCheckboxGroup = ({
  value = [],
  onChange,
  onBlur,
  options,
  error,
  helperText,
}: FocusCheckboxGroupProps) => {
  const selected = Array.isArray(value) ? value : []

  const handleChange = (optionValue: string, checked: boolean) => {
    const next = checked
      ? [...selected, optionValue]
      : selected.filter((v) => v !== optionValue)
    onChange?.(next)
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        {options.map((opt) => (
          <FormControlLabel
            key={opt.value}
            control={
              <Checkbox
                checked={selected.includes(opt.value)}
                onChange={(_, checked) => handleChange(opt.value, checked)}
                onBlur={onBlur}
              />
            }
            label={opt.label}
          />
        ))}
      </Box>
      {error && helperText && (
        <FormHelperText error>{helperText}</FormHelperText>
      )}
    </Box>
  )
}
